import { useNavigate } from 'react-router';

import lang from '../../../lib/language';

import ImageEmpty from '../../../assets/img/package-open.png';
import Button from '../../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../../shared_components/Button/Button.types';
import { UI_ROUTES } from '../../../util/routes';

import styles from './ErrorContent.module.scss';

type Props = {
  tabTitle: string;
};

const ErrorContent = ({ tabTitle }: Props) => {
  const navigate = useNavigate();
  const content = (
    <>
      <p className={styles.noStocksMessage}>{lang.commonMyAccountNoStocksMessage()}</p>
      <div className={styles.wrapperBtnDiscover}>
        <Button
          variant={ButtonTypesEnum.Primary}
          id="discoverButton"
          className={styles.discoverButton}
          onClick={() => navigate(UI_ROUTES.discover)}
        >
          {lang.discoverStocks()}
        </Button>
      </div>
    </>
  );

  return (
    <div className={styles.wrapperNoStocks}>
      <img src={ImageEmpty} alt="no messages logo" />
      {tabTitle.length > 0 && <p className={styles.title}>{tabTitle}</p>}
      {content}
    </div>
  );
};

export default ErrorContent;
